import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ModalService } from 'src/app/modules/modalservice.service';
import { CommonModule, Location, formatDate } from '@angular/common';
import { SitesService } from 'src/app/services/sites.service';
import { VehicleMakesService } from 'src/app/services/vehicle-makes.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { SortComponent } from 'src/app/modules/sort/sort.component';
import { SliderComponent, SliderModule } from '../slider/slider.component';
import { ChatserviceService } from 'src/app/services/chatservice.service';
import { TaskServiceService } from 'src/app/services/task-service.service';

@Component({
  selector: 'app-buy',
  templateUrl: './buy.component.html',
  styleUrls: ['./buy.component.less'],
})
export class BuyComponent implements OnInit {
  fullsizemodelimage: boolean = false;
  SpecialSelectionLayout: any;
  ShowClearance: any;
  ColourSwap: any;
  Truck: any;
  hideFinance: any;
  DealerCategoriesComplete: boolean = false;
  IsAlternativeDetails: boolean = false;
  firstLoadSpecials: boolean = true
  HideTopNavButtons: any;
  HideAllButton: any;
  customOrder: any;
  singleChecked: boolean = true;
  currency: any;
  DataSource: any;
  VehicleMakeTypeExcludeVAT: any = [];
  HideDealerStock: any;
  updatedPrice: any;
  hideSearchFilters: any;
  metaFilters: any [] = []
  H1Title: any;
  H2Title: any;
  result:any[] = [];

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private makesservice: VehicleMakesService,
    private apiservice: GearsApiService,
    private route: ActivatedRoute,
    private modalservice: ModalService,
    public location: Location,
    private siteService: SitesService,
    private chatService: ChatserviceService,
    private taskservice: TaskServiceService
  ) {
    this.searchForm = this.formBuilder.group({
      type: [''],
      make: [-1],
      series: [-1],
      dealership: [-1],
      yearmin: [null],
      yearmax: [null],
      pricemin: [null],
      pricemax: [null],
      kilomin: [null],
      kilomax: [null],
      region: [-1],
      sort: ['RetailPrice.ASC'],
      search: [''],
      fueltype: [-1],
      geartype: [-1],
      bodytype: [-1],
      specialType: [-1],
      sizes: [''],
      range: [''],
    });
  }
  Types: any[] = [
    { Name: 'All', Val: 'all' },
    { Name: 'New', Val: 'new' },
    { Name: 'Demo', Val: 'demo' },
    { Name: 'Used', Val: 'used' },
    { Name: 'Specials', Val: 'specials' },
  ];
  Sorts: any[] = [
    { Name: 'Name A - Z', Value: 'ModelDescription.ASC' },
    { Name: 'Name Z - A', Value: 'ModelDescription.DESC' },
    { Name: 'Price Low - High', Value: 'RetailPrice.ASC' },
    { Name: 'Price High - Low', Value: 'RetailPrice.DESC' },
  ];
  FuelTypes: any = [];
  BodyTypes: any = [];
  GearTypes: any = [];
  Models: any = [];
  Makes: any = [];
  Dealerships: any[] = [];
  Regions: any[] = [];
  Series: any = [];
  Sizes: any = [];
  Range: any = [];
  SpecialsCategories: any[] = [];
  EnquireTitle: any;
  searchForm: FormGroup;
  Site: any;
  pagecount: any = 0;
  count: any = 0;
  Years: any[] = [];
  loading: any = false;
  searchShowing: boolean = false;
  params: { [key: string]: string } = {};
  DealerCategories: any = {
    New: false,
    Used: false,
    Service: false,
    Parts: false,
    Commercials: false
  };
  HideDemo: any;
  HideUsed: boolean = false;
  ModelYears: any;
  hideBodyTypeFilter: boolean = false;

  ngOnInit(): void {
    //this.loadChat();
    this.loading = true;
    this.params['page'] = '1';
    this.params['sort'] = 'RetailPrice.ASC';
    this.route.queryParams.subscribe((qparams) => {
      for (let key in qparams) {
        this.params[key] = qparams[key];
      }
    }); //this.location.go("/buy");
    if (!this.params['type']) {
      var seo = this.route.snapshot.paramMap.get('seo')!;
      var seosplit = (seo ? seo : '').split('-');
      this.params['type'] = seosplit[0] == 'all' ? '' : seosplit[0];
    }
    this.siteService.get().then((x: any) => {
      this.Site = x;
      this.currency = this.Site.CurrencySymbol;
      if (this.Site.layoutFeatures.findIndex((feature: any) => feature.toUpperCase() == 'ISCOMMERCIALENABLED') > -1) {
        this.DealerCategories.Commercials = true;
      }

      this.IsAlternativeDetails = this.Site.layoutGlobal?.some((global:any) => global.PageLayoutTypeName.toUpperCase() == 'ALTERNATIVEDETAILS');
      this.hideFinance = this.Site.layoutGlobal?.some((global: any) => global.PageLayoutTypeName.toUpperCase() == 'HIDEFINANCE');
      this.EnquireTitle = this.Site.layoutGlobal?.some((global: any) => global.PageLayoutTypeName.toUpperCase() == 'ENQUIRETITLE');

      this.customOrder = this.Site.layout
        .find((s:any) => s.PageLayoutModuleName == 'features')?.PageLayoutType
        ?.find((data:any) => data.PageLayoutTypeName == 'customorderby')?.Value;

      this.Truck = this.Site.layout
        .find((s:any) => s.PageLayoutModuleName == 'global')?.PageLayoutType
        ?.find((data:any) => data.PageLayoutTypeName == 'truck');      
      this.Sizes = this.Truck?.Value.Sizes;
      this.Range = this.Truck?.Value.Ranges;

      this.hideBodyTypeFilter = this.Site.layoutFeatures.includes('hidebodytypefilter');
      
      this.HideTopNavButtons = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDETOPNAVBUTTONS');
      this.HideDemo = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDEDEMO');
      this.HideUsed = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDEUSED');
      this.HideDealerStock = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDEDEALERSTOCK');
      this.HideAllButton = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDEALLBUTTON');

      this.hideSearchFilters = this.Site.layoutFeatures.includes('hidesearchfilters');
      this.HideTopNavButtons ? this.params['type'] = 'new' : "";
      this.HideTopNavButtons && this.hideSearchFilters ? this.params['type'] = 'specials' : "";

      this.fullsizemodelimage = this.Site.layout.find((s:any) =>s.PageLayoutModuleName == 'vehicleimages')?.PageLayoutType
        ?.some((data:any) => data.PageLayoutTypeName == 'fullsizemodel');
        
      this.apiservice
        .get(
          'Dealerships',
          {
            Active: 1,
            Deleted: 0,
            PageNumber: 1,
            PageSize: 9999,
            OrderBy: 'Name.ASC',
            SiteID_FK: this.Site.SiteID_PK,
          },
          true
        )
        .then((x: any) => {
          this.Dealerships = x.body;
          this.DataSource = x.body[0].DataSourceID_FK;
          this.Dealerships.forEach((d: any) => {
            if (
              this.Regions.findIndex(
                (b: any) => b.RegionID_PK == d.RegionID_FK
              ) == -1
            )
              this.Regions.push({ Name: d.Region, RegionID_PK: d.RegionID_FK });

            if (d.ServiceDealer) this.DealerCategories.Service = true;
            if (d.UsedDealer) this.DealerCategories.Used = true;
            if (d.NewDealer) this.DealerCategories.New = true;
            if (d.PartsDealer) this.DealerCategories.Parts = true;

            this.Regions.sort((a: any, b: any) => {
              if (a.Name < b.Name) {
                return -1;
              }
              if (a.Name > b.Name) {
                return 1;
              }
              return 0;
            });
            this.Regions.sort();
          });

          this.DealerCategoriesComplete = true;

          this.getMakes();
          this.getModelYears();
          this.getvehicles();
          this.getModelsMakes();
          this.getseries(this.params['make']);
          for (let i = 0; i < 10; i++) {
            this.Years.push(new Date().getFullYear() - i);
          }
        });
    });
  }

  urlsan(url: any) {
    return url
      .replaceAll('+', '')
      .replaceAll('/', '')
      .replaceAll('\\', '')
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll(' ', '-');
  }

  searchfocus(state: boolean) {
    setTimeout(() => {
      this.searchShowing = state;
    }, 500);
  }
  enquire(vehicle: any) {
    var data = {
      ID:
        vehicle.SpecialID_PK ||
        vehicle.VehicleStockID_PK ||
        vehicle.VehicleModelID_PK ||
        vehicle.VehicleID,

      Name: (this.EnquireTitle && vehicle.type == 'NewModel') ? vehicle.VehicleSeries
        : vehicle.WebFriendlyName ? (vehicle.ModelYear + ' ' + vehicle.WebFriendlyName)
          : vehicle.type == 'NewModel' ? vehicle.ModelDescription || vehicle.Caption
            : vehicle.ModelDescription ? (vehicle.ModelYear + ' ' + vehicle.ModelDescription) : vehicle.Caption,

      Dealer: vehicle.GroupSpecial ? null : vehicle.DealershipID_FK,
      Price:
        vehicle.NewVehiclePrice || vehicle.Price || vehicle.RetailPriceIncl,
      Type:
        this.params['type'] !== '' && this.params['type']
          ? this.params['type']
          : vehicle.Type == 'Pre-Owned'
            ? 'used'
            : vehicle.Type.toLowerCase(),
      GenURL: true,
      Source: this.DataSource
    };
    this.modalservice.open('enquire', data);
  }
  suggestedSearch(x: any): boolean {
    if (this.searchForm.controls['search'].value) {
      const searchString = this.searchForm.controls['search'].value.split(' ');
      if ((searchString.length == 1 && searchString.some((y:string) => x.Name.toUpperCase().includes(y.toUpperCase())))
      || (searchString.length > 1 && searchString.every((y:string) => x.Name.toUpperCase().includes(y.toUpperCase())))) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  global: any[7] = [];
 
  filteredBodytypes(): any[] {
    this.global[0] = this.BodyTypes.filter((x: any) => this.suggestedSearch(x));
    return this.global[0];
  }
  filteredFueltypes(): any[] {
    this.global[1] = this.FuelTypes.filter((x: any) => this.suggestedSearch(x));
    return this.global[1];
  }
  filteredGeartypes(): any[] {
    this.global[2] = this.GearTypes.filter((x: any) => this.suggestedSearch(x));
    return this.global[2];
  }
  filteredRegions(): any[] {
    this.global[3] = this.Regions.filter((x: any) => this.suggestedSearch(x));
    return this.global[3];
  }
  filteredMakes(): any[] {
    this.global[4] = this.Makes.filter((x: any) => this.suggestedSearch(x));
    return this.global[4];
  }
  filteredDealerships(): any[] {
    this.global[6] = this.Dealerships.filter((x: any) => this.suggestedSearch(x));
    return this.global[6];
  }
  filteredSeries(): any[] {
    this.global[5] = this.Series.filter(
      (x: any) => {
        if (this.searchForm.controls['search'].value) {
          const searchString = this.searchForm.controls['search'].value.split(' ');
          if (searchString.length == 1) {
            if (searchString.some((y:string) => x.Name.toUpperCase().includes(y.toUpperCase()))
            || searchString.some((y:string) => x.VehicleMake.toUpperCase().includes(y.toUpperCase()))) {
              return true;
            } else {
              return false;
            }
          } else {
            if (searchString.some((y:string) => x.Name.toUpperCase().includes(y.toUpperCase()))
            && searchString.some((y:string) => x.VehicleMake.toUpperCase().includes(y.toUpperCase()))) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return true;
        }
      });
    return this.global[5];
  }
 
  search() {
    const firstIndex = this.global.findIndex((g: any) => g.length > 0);
    this.clearSearchParams();
    switch (firstIndex) {
      case 0:
        // Body Types
        this.addparam('bodytype', this.global[firstIndex][0].VehicleTypeID_PK)
        break;
      case 1:
        // Fuel Types
        this.addparam('fueltype', this.global[firstIndex][0].VehicleFuelTypeID_PK)
        break;
      case 2:
        // Gear Types
        this.addparam('geartype', this.global[firstIndex][0].VehicleTransmissionID_PK)
        break;
      case 3:
        // Regions
        this.addparam('region', this.global[firstIndex][0].RegionID_PK)
        break;
      case 4:
        // Makes
        this.addparam('make', this.global[firstIndex][0].VehicleMakeID_PK)
        break;
      case 5:
        // Series
        this.addparam('series', this.global[firstIndex][0].VehicleSeriesID_PK || this.global[firstIndex][0].VehicleSeriesID_FK)
        break;
      case 6:
        // Dealerships
        this.addparam('dealership', this.global[firstIndex][0].DealershipID_PK)
        break;
    }
  }
  
  filteredTypes(): any[] {
    return this.Types.filter((x: any) => this.suggestedSearch(x));
  }

  clearSearchParams() {
    this.params['dealership'] = '';
    this.params['make'] = '';
    this.params['series'] = '';
    this.params['bodytype'] = '';
    this.params['fueltype'] = '';
    this.params['geartype'] = '';
    this.params['region'] = '';  
  }

  isfav(v: any, type: string) {
    return JSON.parse(localStorage.getItem('fav') || '[]').includes(
      type + '-' + (v.VehicleStockID_PK || v.VehicleModelID_PK || v.VehicleID)
    );
  }

  fav(id: string, type: string) {
    var favs: any[] = JSON.parse(localStorage.getItem('fav') || '[]');
    if (!favs.includes(type + '-' + id)) {
      favs.push(type + '-' + id);
    } else {
      const index = favs.indexOf(type + '-' + id);
      if (index > -1) {
        favs.splice(index, 1);
      }
    }
    localStorage.setItem('fav', JSON.stringify(favs));
  }
  addparam(par: any, val: any) {
    this.searchShowing = false;
    this.searchForm.controls['search'].setValue('');
    this.params[par] = val;
    this.locationgo();
    this.updateUrl();
  }
  getvehicles() {
    let price = '';
    let pricemin: number = +this.params['pricemin']/1000;
    let pricemax: number = +this.params['pricemax']/1000;
    price = (pricemin && pricemax) ?
      '(' + this.currency + pricemin + 'K-' + this.currency + pricemax + 'K)' :
      pricemax ? 'Under ' + this.currency + pricemax + 'K' :
      pricemin ? 'Over ' + this.currency + pricemin + 'K' :
      '';
    this.loading = true;
    if (this.params['type'] && this.params['type'] !== '') {

      if (this.params['type'] == 'new' || this.params['type'] == 'commercials') {
        this.getBodyTypes(this.params['type']);
        this.apiservice
          .get('VehicleModels', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            PageSize: 8,
            PageNumber: this.params['page'],
            OrderBy: this.customOrder ? this.customOrder : this.params['sort'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            VehicleTransmissionId_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['type'] == 'commercials' ? 2 : this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            SiteID_FK: this.Site.SiteID_PK,
            IsCommercialSite: this.DealerCategories.Commercials ? 1 : 0,
            MaxVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.max,
            MinVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.min,
            VehicleTypeBodyType: this.Range?.find((data: any) => data.name == this.params['range'])?.name
          })
          .then((x: any) => {
            if (this.params['type'] == 'new' || this.params['type'] == 'commercials') {
              if (this.params['specialType'] != '') {
                this.params['specialType'] = '';
                this.updateUrl();
              }
              this.Models = x.body;
              this.metaFilters = [
                {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails || this.params['type'] == 'commercials') ? "Trucks" : "Cars",
                "transmission": this.GearTypes.find((values:any) => values.VehicleTransmissionID_PK == this.params['geartype'])?.Name ?? "",
                "stocktype": this.titleCase(this.params['type']) ?? "",
                "make": this.Makes.length == 1 ? this.titleCase(this.Makes[0].Name) : this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                "fueltype": this.FuelTypes.find((values:any) => values.VehicleFuelTypeID_PK == this.params['fueltype'])?.Name ?? "",
                "bodytype": this.BodyTypes.find((values:any) => values.VehicleTypeID_PK == this.params['bodytype'])?.Name ?? "",
                "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                "price": price,
                "sitename": this.Site.Name}
              ];
              this.taskservice.titleUpdate("New Vehicles", this.Site.SiteID_PK, this.metaFilters);

              if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
                this.params['bodytype'] = '';
                this.searchForm.controls['bodytype'].setValue(-1);
                this.updateUrl();
                this.getvehicles();
              } else {
                if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                  this.params['series'] = '';
                  this.searchForm.controls['series'].setValue(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                    this.params['make'] = '';
                    this.searchForm.controls['make'].setValue(-1);
                    this.getseries(-1);
                    this.updateUrl();
                    this.getvehicles();
                  } else {
                    this.HeaderVehicleSeries();
                    this.count = x.count;
                    this.pagecount = Math.ceil(x.count / 8);
                    this.Models.forEach((element: any) => {
                      element.type = 'NewModel';
                      this.prefetchPages('NewModel');
                      element.NewVehiclePrice = this.DataSource == 1 ? element.NewVehiclePrice : element.NamibiaNewVehiclePrice;
                      //element.Images = element.Images.to
                    });
                    this.loading = false;
                    if (this.customOrder) {
                      if (x.body.length == 1 && this.singleChecked) {
                        this.singleChecked = false;
                        this.href("buy/new/" + x.body[0].VehicleModelID_PK + "/" + this.urlsan(x.body[0].ModelDescription));
                      }
                    }
                  }
                }
              }
            }
          });
      }
      if (this.params['type'] == 'newstock') {
        this.getBodyTypes(this.params['type']);
        this.apiservice
          .get('VehicleStock', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            VehicleStockType: 'NEW',
            PageSize: 8,
            PageNumber: this.params['page'],
            OrderBy: this.params['sort'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            VehicleModelID_FK: this.params['model']
              ? this.params['model']
              : undefined,
            MaxYear: this.params['yearmax'],
            MinYear: this.params['yearmin'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            MaxMileage: this.params['kilomax'],
            MinMileage: this.params['kilomin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            SiteID_FK: this.Site.SiteID_PK,
            CampaignVehicle: this.params['campaignvehicles']
          })
          .then((x: any) => {
            if (this.params['type'] == 'newstock') {
              if (this.params['specialType'] != '') {
                this.params['specialType'] = '';
                this.updateUrl();
              }

              this.metaFilters = [
                {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
                "transmission": this.GearTypes.find((values:any) => values.VehicleTransmissionID_PK == this.params['geartype'])?.Name ?? "",
                "stocktype": "New",
                "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                "fueltype": this.FuelTypes.find((values:any) => values.VehicleFuelTypeID_PK == this.params['fueltype'])?.Name ?? "",
                "bodytype": this.BodyTypes.find((values:any) => values.VehicleTypeID_PK == this.params['bodytype'])?.Name ?? "",
                "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                "price": price,
                "sitename": this.Site.Name}
              ];
              this.taskservice.titleUpdate("New Vehicles", this.Site.SiteID_PK, this.metaFilters);

              if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
                this.params['bodytype'] = '';
                this.searchForm.controls['bodytype'].setValue(-1);
                this.updateUrl();
                this.getvehicles();
              } else {
                if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                  this.params['series'] = '';
                  this.searchForm.controls['series'].setValue(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                    this.params['make'] = '';
                    this.searchForm.controls['make'].setValue(-1);
                    this.getseries(-1);
                    this.updateUrl();
                    this.getvehicles();
                  } else {
                    this.Models = x.body;
                    this.HeaderVehicleSeries();
                    this.count = x.count;
                    this.pagecount = Math.ceil(x.count / 8);
                    this.Models.forEach((element: any) => {
                      element.type = 'new';
                    });
                    this.loading = false;
                    this.prefetchPages('NEW');
                  }
                }
              }
            }
          });
      }
      if (this.params['type'] == 'used') {
        this.getBodyTypes('PREOWNED');

        this.ShowClearance = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'SHOWCLEARANCE');

        this.ColourSwap = this.Site.layoutGlobal?.find((bottomnav: any) => bottomnav.PageLayoutTypeName.toUpperCase() == 'BUTTONSECONDARY')?.Value;

        if (this.ColourSwap) {
          var buttonstyle = document.createElement('style');
          buttonstyle.innerText = '.listings{background-color:var(--secondary) !important;border-color:var(--secondary) !important; color:white !important} .listings{color:var(--primary) !important}';
          document.head.appendChild(buttonstyle!);
        }

        this.apiservice
          .get('VehicleStock', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            VehicleStockType: 'PREOWNED',
            PageSize: 8,
            PageNumber: this.params['page'],
            OrderBy: this.params['sort'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            MaxYear: this.params['yearmax'],
            MinYear: this.params['yearmin'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            MaxMileage: this.params['kilomax'],
            MinMileage: this.params['kilomin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            SiteID_FK: this.Site.SiteID_PK,
            CampaignVehicle: this.params['campaignvehicles']
          })
          .then((x: any) => {
            if (this.params['type'] == 'used') {
              if (this.params['specialType'] != '') {
                this.params['specialType'] = '';
                this.updateUrl();
              }

              this.metaFilters = [
                {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
                "transmission": this.GearTypes.find((values:any) => values.VehicleTransmissionID_PK == this.params['geartype'])?.Name ?? "",
                "stocktype": "Used",
                "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                "fueltype": this.FuelTypes.find((values:any) => values.VehicleFuelTypeID_PK == this.params['fueltype'])?.Name ?? "",
                "bodytype": this.BodyTypes.find((values:any) => values.VehicleTypeID_PK == this.params['bodytype'])?.Name ?? "",
                "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                "price": price,
                "sitename": this.Site.Name}
              ];
              this.taskservice.titleUpdate("Pre-Owned Vehicles", this.Site.SiteID_PK, this.metaFilters);

              if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
                this.params['bodytype'] = '';
                this.searchForm.controls['bodytype'].setValue(-1);
                this.updateUrl();
                this.getvehicles();
              } else {
                if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                  this.params['series'] = '';
                  this.searchForm.controls['series'].setValue(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                    this.params['make'] = '';
                    this.searchForm.controls['make'].setValue(-1);
                    this.getseries(-1);
                    this.updateUrl();
                    this.getvehicles();
                  } else {
                    this.Models = x.body;
                    this.HeaderVehicleSeries();
                    this.count = x.count;
                    this.pagecount = Math.ceil(x.count / 8);
                    this.Models.forEach((element: any) => {
                      element.type = 'used';
                    });
                    this.loading = false;
                    this.prefetchPages('PREOWNED');
                  }
                }
              }
            }
          });
      }
      if (this.params['type'] == 'demo') {
        this.getBodyTypes('DEMO');

        this.ShowClearance = this.Site.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'SHOWCLEARANCE');

        this.ColourSwap = this.Site.layoutGlobal?.find((bottomnav: any) => bottomnav.PageLayoutTypeName.toUpperCase() == 'BUTTONSECONDARY')?.Value;

        if (this.ColourSwap) {
          var buttonstyle = document.createElement('style');
          buttonstyle.innerText = '.listings{background-color:var(--secondary) !important;border-color:var(--secondary) !important; color:white !important} .listings{color:var(--primary) !important}';
          document.head.appendChild(buttonstyle!);
        }

        this.apiservice
          .get('VehicleStock', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            VehicleStockType: 'DEMO',
            PageSize: 8,
            PageNumber: this.params['page'],
            OrderBy: this.params['sort'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            MaxYear: this.params['yearmax'],
            MinYear: this.params['yearmin'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            MaxMileage: this.params['kilomax'],
            MinMileage: this.params['kilomin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            SiteID_FK: this.Site.SiteID_PK,
            CampaignVehicle: this.params['campaignvehicles']
          })
          .then((x: any) => {
            if (this.params['type'] == 'demo') {
              if (this.params['specialType'] != '') {
                this.params['specialType'] = '';
                this.updateUrl();
              }

              this.metaFilters = [
                {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
                "transmission": this.GearTypes.find((values:any) => values.VehicleTransmissionID_PK == this.params['geartype'])?.Name ?? "",
                "stocktype": "Demo",
                "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                "fueltype": this.FuelTypes.find((values:any) => values.VehicleFuelTypeID_PK == this.params['fueltype'])?.Name ?? "",
                "bodytype": this.BodyTypes.find((values:any) => values.VehicleTypeID_PK == this.params['bodytype'])?.Name ?? "",
                "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                "price": price,
                "sitename": this.Site.Name}
              ];
              this.taskservice.titleUpdate("Demo Vehicles", this.Site.SiteID_PK, this.metaFilters);

              if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
                this.params['bodytype'] = '';
                this.searchForm.controls['bodytype'].setValue(-1);
                this.updateUrl();
                this.getvehicles();
              } else {
                if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                  this.params['series'] = '';
                  this.searchForm.controls['series'].setValue(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                    this.params['make'] = '';
                    this.searchForm.controls['make'].setValue(-1);
                    this.getseries(-1);
                    this.updateUrl();
                    this.getvehicles();
                  } else {
                    this.Models = x.body;
                    this.HeaderVehicleSeries();
                    this.count = x.count;
                    this.pagecount = Math.ceil(x.count / 8);
                    this.Models.forEach((element: any) => {
                      element.type = 'used';
                    });
                    this.loading = false;
                    this.prefetchPages('DEMO');
                  }
                }
              }
            }
          });
      }
      if (this.params['type'].includes('specials')) {

        if (!sessionStorage.getItem('RandSeed')) {
          sessionStorage.setItem(
            'RandSeed',
            Math.floor(Math.random() * 1000000000).toString()
          );
        }

        var SpecialRandSeed: any;
        this.SpecialSelectionLayout = this.Site.layoutGlobal?.find((bottomnav: any) => bottomnav.PageLayoutTypeName.toUpperCase() == 'SPECIALSELECTION')?.Value;
        var SpecialSelection
        if (!this.SpecialSelectionLayout || this.SpecialSelectionLayout == null) {
          SpecialSelection =
            this.grouponly() ? 'SalesOrder.ASC' : (this.params['dealership'] == undefined ||
              this.params['dealership'] == '' ||
              this.params['dealership'] == null) &&
              this.Dealerships.length > 1 ? 'GroupSpecial.DESC' : 'GroupSpecial.ASC';
        }
        else {
          SpecialSelection = 'Random';
          SpecialRandSeed = sessionStorage.getItem('RandSeed');//Math.floor(Math.random() * 1000000000).toString()
          if (this.firstLoadSpecials && this.loading) {
            this.params['specialType'] = this.SpecialsCategories.find((s: any) => s.Code == 'New')?.SpecialCategoryID_PK;
          }
        }

        this.apiservice
          .get('Specials', {
            Active: 1,
            DateEnd: formatDate(Date.now(), 'yyyy-MM-dd', this.locale),
            Deleted: 0,
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            OrderBy:
              SpecialSelection,
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            PageNumber: this.params['page'],
            PageSize: 8,
            SpecialCategoryID_FK: this.params['specialType'],
            GroupSpecial: this.grouponly(),
            RandomSeed: SpecialRandSeed,
            SiteID_FK: this.Site.SiteID_PK,
          })
          .then((x: any) => {
            if (
              x.count == 0 &&
              (this.params['dealership'] == undefined ||
                this.params['dealership'] == '' ||
                this.params['dealership'] == null) &&
              this.Dealerships.length > 1
            ) {

              this.apiservice
                .get('Specials', {
                  Active: 1,
                  DateEnd: formatDate(Date.now(), 'yyyy-MM-dd', this.locale),
                  Deleted: 0,
                  VehicleSeriesID_FK: this.params['series']
                    ? this.params['series']
                    : undefined,
                  OrderBy: 'Random.ASC',
                  MaxPrice: this.params['pricemax'],
                  MinPrice: this.params['pricemin'],
                  VehicleTransmissionID_FK: this.params['geartype'],
                  VehicleTypeID_FK: this.params['bodytype'],
                  VehicleFuelTypeID_FK: this.params['fueltype'],
                  RegionID_FK: this.params['region'],
                  Search: this.params['search'],
                  PageNumber: this.params['page'],
                  PageSize: 8,
                  SpecialCategoryID_FK: this.params['specialType'],
                  RandomSeed: sessionStorage.getItem('RandSeed'),
                  SiteID_FK: this.Site.SiteID_PK,
                })
                .then((x: any) => {
                  if (this.params['type'].includes('specials')) {

                    this.metaFilters = [
                      {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
                      "transmission": "",
                      "stocktype": "Specials",
                      "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                      "fueltype": "",
                      "bodytype": "",
                      "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                      "price": "",
                      "sitename": this.Site.Name}
                    ];
                    this.taskservice.titleUpdate("Specials", this.Site.SiteID_PK, this.metaFilters);

                    if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
                      this.params['bodytype'] = '';
                      this.searchForm.controls['bodytype'].setValue(-1);
                      this.updateUrl();
                      this.getvehicles();
                    } else {
                      if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                        this.params['series'] = '';
                        this.searchForm.controls['series'].setValue(-1);
                        this.updateUrl();
                        this.getvehicles();
                      } else {
                        if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                          this.params['make'] = '';
                          this.searchForm.controls['make'].setValue(-1);
                          this.getseries(-1);
                          this.updateUrl();
                          this.getvehicles();
                        } else {
                          this.Models = x.body;
                          this.HeaderVehicleSeries();
                          this.count = x.count;
                          this.pagecount = Math.ceil(x.count / 8);
                          this.Models.forEach((element: any) => {
                            element.type = 'special';
                          });
                          this.loading = false;
                        }
                      }
                    }
                  }
                });
            } else {
              if (this.params['type'].includes('specials')) {

                this.metaFilters = [
                  {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
                  "transmission": "",
                  "stocktype": "Specials",
                  "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
                  "fueltype": "",
                  "bodytype": "",
                  "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
                  "price": "",
                  "sitename": this.Site.Name}
                ];
                this.taskservice.titleUpdate("Specials", this.Site.SiteID_PK, this.metaFilters);

                if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                  this.params['series'] = '';
                  this.searchForm.controls['series'].setValue(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                    this.params['make'] = '';
                    this.searchForm.controls['make'].setValue(-1);
                    this.getseries(-1);
                    this.updateUrl();
                    this.getvehicles();
                  } else {
                    this.Models = x.body;
                    this.HeaderVehicleSeries();
                    this.count = x.count;
                    this.pagecount = Math.ceil(x.count / 8);
                    this.Models.forEach((element: any) => {
                      element.type = 'special';
                    });
                    this.loading = false;
                    this.firstLoadSpecials = false;
                  }
                }
              }
            }
          });
      }
    } else {
      this.getBodyTypes('ALL');
      this.apiservice
        .get('AllVehicles', {
          VehicleMakeID_FK: this.params['make']
            ? this.params['make']
            : undefined,
          PageSize: 8,
          PageNumber: this.params['page'],
          OrderBy: this.params['sort'],
          MaxYear: this.params['yearmax'],
          MinYear: this.params['yearmin'],
          MaxPrice: this.params['pricemax'],
          MinPrice: this.params['pricemin'],
          MaxMileage: this.params['kilomax'],
          MinMileage: this.params['kilomin'],
          VehicleTransmissionID_FK: this.params['geartype'],
          VehicleTransmissionId_FK: this.params['geartype'],
          VehicleTypeID_FK: this.params['bodytype'],
          VehicleFuelTypeID_FK: this.params['fueltype'],
          DealershipID_FK: this.params['dealership'],
          RegionID_FK: this.params['region'],
          Search: this.params['search'],
          VehicleSeriesID_FK: this.params['series']
            ? this.params['series']
            : undefined,
          SiteID_FK: this.Site.SiteID_PK,
          PreownedLast: this.IsAlternativeDetails ? true : false
        })
        .then((x: any) => {
          if (this.params['specialType'] != '') {
            this.params['specialType'] = '';
            this.updateUrl();
          }

          this.metaFilters = [
            {"series": this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name ? this.titleCase(this.Series.find((values:any) => values.VehicleSeriesID_PK == this.params['series'])?.Name) : (this.Truck || this.IsAlternativeDetails) ? "Trucks" : "Cars",
            "transmission": this.GearTypes.find((values:any) => values.VehicleTransmissionID_PK == this.params['geartype'])?.Name ?? "",
            "stocktype": "All",
            "make": this.titleCase(this.Makes.find((values:any) => values.VehicleMakeID_PK == this.params['make'])?.Name) ?? "",
            "fueltype": this.FuelTypes.find((values:any) => values.VehicleFuelTypeID_PK == this.params['fueltype'])?.Name ?? "",
            "bodytype": this.BodyTypes.find((values:any) => values.VehicleTypeID_PK == this.params['bodytype'])?.Name ?? "",
            "region": this.Regions.find((values:any) => values.RegionID_PK == this.params['region'])?.Name ?? "",
            "price": price,
            "sitename": this.Site.Name}
          ];
          this.taskservice.titleUpdate("Home", this.Site.SiteID_PK, this.metaFilters);

          if (!(this.params['type'] && this.params['type'] !== '')) {
            if (x.body.length == 0 && (this.params['bodytype'] != '' && this.params['bodytype'] != '-1' && this.params['bodytype'] != undefined)) {
              this.params['bodytype'] = '';
              this.searchForm.controls['bodytype'].setValue(-1);
              this.updateUrl();
              this.getvehicles();
            } else {
              if (x.body.length == 0 && (this.params['series'] != '' && this.params['series'] != '-1' && this.params['series'] != undefined)) {
                this.params['series'] = '';
                this.searchForm.controls['series'].setValue(-1);
                this.updateUrl();
                this.getvehicles();
              } else {
                if (x.body.length == 0 && (this.params['make'] != '' && this.params['make'] != '-1' && this.params['make'] != undefined)) {
                  this.params['make'] = '';
                  this.searchForm.controls['make'].setValue(-1);
                  this.getseries(-1);
                  this.updateUrl();
                  this.getvehicles();
                } else {
                  this.Models = x.body;
                  this.HeaderVehicleSeries();
                  this.count = x.count;
                  this.pagecount = Math.ceil(x.count / 8);
                  this.Models.forEach((element: any) => {
                    element.type = element.Type == 'NewModel' ? 'NewModel' : 'used';
                    if (element.type == 'NewModel') {
                      element.NewVehiclePrice = this.DataSource == 1 ? element.NewVehiclePrice : element.NamibiaNewVehiclePrice;
                    }
                    if (element.ImagesList !== null)
                      element.Images = element.ImagesList.split(',');
                    let index = element.Images?.findIndex((image: string) => image.includes('main'));
                    if (index && index !== -1) {
                      let matchedName = element.Images[index];
                      element.Images.splice(index, 1);
                      element.Images.unshift(matchedName);
                    }
                  });
                  this.loading = false;
                  this.prefetchPages();
                }
              }
            }
          }
        });
    }
  }

  grouponly() {
    return ((this.params['dealership'] == undefined ||
      this.params['dealership'] == '' ||
      this.params['dealership'] == null) &&
      this.Dealerships.length > 1) &&
      (this.params['make'] == undefined ||
        this.params['make'] == '' ||
        this.params['make'] == null) &&
      (this.params['series'] == undefined ||
        this.params['series'] == '' ||
        this.params['series'] == null) &&
      (this.params['yearmin'] == undefined ||
        this.params['yearmin'] == '' ||
        this.params['yearmin'] == null) &&
      (this.params['yearmax'] == undefined ||
        this.params['yearmax'] == '' ||
        this.params['yearmax'] == null) &&
      (this.params['pricemin'] == undefined ||
        this.params['pricemin'] == '' ||
        this.params['pricemin'] == null) &&
      (this.params['pricemax'] == undefined ||
        this.params['pricemax'] == '' ||
        this.params['pricemax'] == null) &&
      (this.params['kilomin'] == undefined ||
        this.params['kilomin'] == '' ||
        this.params['kilomin'] == null) &&
      (this.params['kilomax'] == undefined ||
        this.params['kilomax'] == '' ||
        this.params['kilomax'] == null) &&
      (this.params['region'] == undefined ||
        this.params['region'] == '' ||
        this.params['region'] == null) &&
      (this.params['search'] == undefined ||
        this.params['search'] == '' ||
        this.params['search'] == null) &&
      (this.params['fueltype'] == undefined ||
        this.params['fueltype'] == '' ||
        this.params['fueltype'] == null) &&
      (this.params['geartype'] == undefined ||
        this.params['geartype'] == '' ||
        this.params['geartype'] == null) &&
      (this.params['bodytype'] == undefined ||
        this.params['bodytype'] == '' ||
        this.params['bodytype'] == null) &&
      (this.params['specialType'] == undefined ||
        this.params['specialType'] == '' ||
        this.params['specialType'] == null)
      ? true
      : false;
  }
  clear() {
    var type = this.params['type'];
    this.params = {};
    this.params['page'] = '1';
    this.params['type'] = type;
    this.params['sort'] = 'RetailPrice.ASC';
    this.locationgo();
    this.updateUrl();
  }
  imgadd(url: string) {
    if (!url.includes('http')) {
      return environment.storageurl + url;
    } else {
      return url;
    }
  }
  regionDealers(region: any) {
    return this.Dealerships.filter((x: any) => x.Region == region);
  }

  makeSeries(make: any) {
    return this.Series.filter((x: any) => x.VehicleMakeID_FK == make);
  }

  getBodyTypes(activeTab: any) {
    if (activeTab != 'commercials') {
      this.apiservice
        .get(
          'VehicleTypes/ActiveVehicles',
          {
            VehicleTypeID_PK: activeTab == 'commercials' ? 2 : undefined,
            IsCommercialSite: this.DealerCategories.Commercials ? 1 : 0,
            Active: 1,
            Deleted: 0,
            PageNumber: 1,
            PageSize: 9999,
            OrderBy: 'Name.ASC',
            SiteID_FK: this.Site.SiteID_PK,
            VehicleStockType: activeTab.toUpperCase()
          },
          true
        )
        .then((x: any) => {
          this.BodyTypes = x.body;
        });
    }
    else {
      this.BodyTypes = [];
    }

  }

  getModelsMakes() {
    //this.apiservice.get('Regions', { Active: 1, Deleted: 0, PageNumber: 1, PageSize: 9999, OrderBy: 'Name.ASC', SiteID_FK: this.siteid }, true).then((x: any) => { this.Regions = x.body });

    this.apiservice
      .get(
        'SiteSpecialCategories',
        {
          Active: 1,
          Deleted: 0,
          PageNumber: 1,
          PageSize: 9999,
          OrderBy: 'Name.ASC',
          SiteID_FK: this.Site.SiteID_PK,
        },
        true
      )
      .then((x: any) => {
        this.SpecialsCategories = x.body;
        if (this.SpecialSelectionLayout && this.params['type'] == 'specials') {
          this.params['specialType'] = this.SpecialsCategories.find((s: any) => s.Code == 'New')?.SpecialCategoryID_PK;
          this.updateUrl();
          this.getvehicles();
        }
      });
    this.apiservice
      .get(
        'VehicleFuelTypes',
        {
          Active: 1,
          Deleted: 0,
          PageNumber: 1,
          PageSize: 9999,
          OrderBy: 'Name.ASC',
          SiteID_FK: this.Site.SiteID_PK,
        },
        true
      )
      .then((x: any) => {
        this.FuelTypes = x.body;
      });
    this.apiservice
      .get(
        'VehicleTransmissions',
        {
          Active: 1,
          Deleted: 0,
          PageNumber: 1,
          PageSize: 9999,
          OrderBy: 'Name.ASC',
          SiteID_FK: this.Site.SiteID_PK,
        },
        true
      )
      .then((x: any) => {
        if (this.Truck = this.Site.layout
          .find((s:any) => s.PageLayoutModuleName == 'global')?.PageLayoutType
          ?.find((data:any) => data.PageLayoutTypeName == 'truck'))
        {
          this.GearTypes = x.body.filter((y:any)=> y.Name != "CVT" && y.Name != "Unknown");
        }
        else {
          this.GearTypes = x.body;
        }
      });
  }
  filters() {
    // var data = {Name:this.Model.ModelDescription};
    this.modalService.open('filters', '');
  }
  sort() {
    // var data = {Name:this.Model.ModelDescription};
    this.modalService.open('sort', '');
  }
  nextpage() {
    this.params['page'] = (Number.parseInt(this.params['page']) + 1).toString();
    this.locationgo();
  }
  prevpage() {
    this.params['page'] = (Number.parseInt(this.params['page']) - 1).toString();
    this.locationgo();
  }
  firstpage() {
    this.params['page'] = '1';
    this.locationgo();
  }
  lastpage() {
    this.params['page'] = this.pagecount;
    this.locationgo();
  }

  locationgo() {
    this.Models = [];
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.updateUrl();
    this.getvehicles();
  }

  HeaderVehicleSeries() {
    let dups:any[] = [];
    this.result = [];
    if (this.Models?.length > 0) {
      if (this.params['type'] != 'special') {
        for (let i = 0; i < this.Models.length; i++) {
          if (this.result.length == 0) {
            this.result.push(this.Models[0])
          }
          else if (!this.result.some((r:any) => r?.VehicleSeriesID_FK == this.Models[i].VehicleSeriesID_FK)) {
            this.result.push(this.Models[i]);
          } else {
            dups.push(this.Models[i]);
          }
        };
        let region = this.DataSource == 2 ? ' in Namibia' : this.Site.dealerSite ? ' in ' + this.Dealerships[0].AddressPhysicalCity : this.metaFilters[0].region ? ' in ' + this.metaFilters[0].region : ' in South Africa';
        let price = this.metaFilters[0].price != '' ? ' For ' + this.metaFilters[0].price : '';
        this.H1Title = (`${this.metaFilters[0].stocktype} ${this.metaFilters[0].make} ${this.metaFilters[0].transmission} ${this.metaFilters[0].fueltype} ${this.metaFilters[0].bodytype} ${this.metaFilters[0].series} For Sale ${region}${price}`).replace(/\s{2,}/g, " ");
        if (this.params['type'] == 'new') {
          this.H2Title = "Top Models Available"
        }
        if (this.params['type'] == 'used') {
          this.H2Title = "Browse Popular Pre-Owned Models"
        }
        if (this.params['type'] == 'demo') {
          this.H2Title = "Explore Our Demo Range"
        }
        if (this.params['type'] == 'newstock') {
          this.H2Title = "Explore Our New Stock"
        }
        if (this.params['type'] == '') {
          this.H2Title = "Browse All Available Vehicles"
        }
      } else {
        this.result = this.Models;
        this.H2Title = "Latest Promotions"
      }
     
      if (this.result?.length >= 3){
        this.result = this.result.slice(0, 3);
      } else {
        this.result = this.result.slice(0, this.result?.length);
        if(dups?.length > 0) {
          for (let i = 0; i < (3 - this.result?.length); i++) {
            if (dups[i]) this.result.push(dups[i]);
          }
        };
      }

      let seriesString = '';
      if (this.result.length == 3) {
        if (this.metaFilters[0].stocktype != 'Specials') {
          seriesString = this.titleCase(this.result[0].VehicleSeries) + ', ' + this.titleCase(this.result[1].VehicleSeries) + ' & ' + this.titleCase(this.result[2].VehicleSeries);
        } else {
          seriesString = this.titleCase(this.result[0].Caption) + ', ' + this.titleCase(this.result[1].Caption) + ' & ' + this.titleCase(this.result[2].Caption);
        } 
      } else if (this.result.length == 2) {
        if (this.metaFilters[0].stocktype != 'Specials') {
          seriesString = this.titleCase(this.result[0].VehicleSeries) + ' & ' + this.titleCase(this.result[1].VehicleSeries);
        } else {
          seriesString = this.titleCase(this.result[0].Caption) + ' & ' + this.titleCase(this.result[1].Caption);
        }
      } else {
        if (this.metaFilters[0].stocktype != 'Specials') {
          seriesString = this.titleCase(this.result[0].VehicleSeries);
        } else {
          seriesString = this.titleCase(this.result[0].Caption);
        }
      }
      this.metaFilters.push(seriesString);
    }
  }

  updateUrl() {
    var parms = '';
    for (let key in this.params) {
      var blocked = false;
      if (key == 'type') {
        blocked = true;
      }
      if (key == 'page' && this.params[key] == '1') {
        blocked = true;
      }
      if (key == 'sort' && this.params[key] == 'RetailPrice.ASC') {
        blocked = true;
      }
      if (this.params[key] != '-1' && this.params[key] != '' && this.params[key] != undefined && !blocked) {
        parms += key + '=' + this.params[key] + '&';
      }
    }

    //kilomin=12300&series=1454&yearmax=2020&pricemin=120&pricemax=4561561&kilomax=3145454&region=1&dealership=273&fueltype=2&geartype=1&bodytype=14

    var seoparms = '';
    if (
      this.params['type'] != '' &&
      this.params['type'] &&
      this.params['type'] != '-1' &&
      this.params['type'] != null
    ) {
      seoparms +=
        this.params['type'] ?? 'all';
    } else {
      seoparms += 'all';
    }

    var vehicle = '';
    if (this.params['type'] == 'new' && this.Makes.length == 1) {
      vehicle += this.Makes[0]?.Name ? '-' + this.Makes[0]?.Name : '';
    }
    else if (
      this.params['make'] != '' &&
      this.params['make'] &&
      this.params['make'] != '-1' &&
      this.params['make'] != null
    ) {
      let makename = this.Makes.find((x: any) => x.VehicleMakeID_PK == this.params['make'])?.Name;
      vehicle += makename ? '-' + makename : '';
    }
    if (
      this.params['geartype'] != '' &&
      this.params['geartype'] &&
      this.params['geartype'] != '-1' &&
      this.params['geartype'] != null
    ) {
      let transmission = this.GearTypes.find(
        (x: any) => x.VehicleTransmissionID_PK == this.params['geartype']
      )?.Name;
      vehicle += transmission ? '-' + transmission : '';
    }
    if (
      this.params['fueltype'] != '' &&
      this.params['fueltype'] &&
      this.params['fueltype'] != '-1' &&
      this.params['fueltype'] != null
    ) {
      let fueltype = this.FuelTypes.find(
        (x: any) => x.VehicleFuelTypeID_PK == this.params['fueltype']
      )?.Name;
      vehicle += fueltype ? '-' + fueltype : '';
    }
    if (
      this.params['bodytype'] != '' &&
      this.params['bodytype'] &&
      this.params['bodytype'] != '-1' &&
      this.params['bodytype'] != null
    ) {
      let bodytype = this.BodyTypes.find(
        (x: any) => x.VehicleTypeID_PK == this.params['bodytype']
      )?.Name;
      vehicle += bodytype ? '-' + bodytype : '';
    }
    if (
      this.params['series'] != '' &&
      this.params['series'] &&
      this.params['series'] != '-1'
    ) {
      let seriesname = this.Series.find(
        (x: any) => x.VehicleSeriesID_PK == this.params['series']
      )?.Name;
      vehicle += seriesname ? '-' + seriesname : '';
    }

    if (vehicle == '') {
      seoparms +=
        '-cars';
    } else {
      seoparms += vehicle;
    }
    seoparms += '-for-sale';
    /*if (this.params['dealership'] != '' && this.params['dealership']) {
      seoparms +=
        '-' +
          this.Dealerships.find(
            (x: any) => x.DealershipID_PK == this.params['dealership']
          ).Name ?? '';
    }*/
    if (this.params['pricemin'] || this.params['pricemax']) {
      let pricemin: number = +this.params['pricemin']/1000;
      let pricemax: number = +this.params['pricemax']/1000;
      let price = (pricemin && pricemax) ?
        '-' + this.currency + pricemin + 'k-' + this.currency + pricemax + 'k' :
        pricemax ? '-under-' + this.currency + pricemax + 'k' :
        pricemin ? '-over-' + this.currency + pricemin + 'k' :
        '';
      seoparms += price;
    }

    if (this.params['region'] != '' && this.params['region']) {
      let regionname = this.Regions.find((x: any) => x.RegionID_PK == this.params['region']).Name;
      seoparms += regionname ? '-' + regionname : '';
    } else if (this.Site.dealerSite) {
      let cityname = this.Dealerships[0].AddressPhysicalCity;
      seoparms += '-' + cityname;
    } else {
      if (this.DataSource == 2) {
        seoparms += '-namibia';
      } else {
        seoparms += '-south-africa';
      }
    }

    if (seoparms.length > 0) {
      seoparms = '/' + this.urlsan(seoparms).toLowerCase();
    }

    parms = parms.slice(0, -1);
    this.location.go('/buy' + seoparms + (parms == '' ? '' : ('?' + parms)));
    this.taskservice.navUpdate();
  }
  href(ref: string) {
    window.location.href = ref;
  }

  prefetchData(type: string, id: any) {
    if (type.toLowerCase() == 'stock') {
      this.apiservice.getSingle('VehicleStock', id);
    } else if (type.toLowerCase() == 'new') {
      this.apiservice.getSingle('VehicleModels', id);
    }
  }
  go(param: string, line: string) {
    setTimeout(() => {
      this.searchForm.controls['make'].setValue(this.params['make'] == '' || this.params['make'] == '-1' || this.params['make'] == undefined ? -1 : this.params['make']);
      this.searchForm.controls['series'].setValue(this.params['series'] == '' || this.params['series'] == '-1' || this.params['series'] == undefined ? -1 : this.params['series']);
      if (this.params['type'] == 'specials') {
        delete this.params['yearmin'];
        delete this.params['yearmax'];
        delete this.params['kilomin'];
        delete this.params['kilomax'];
        delete this.params['geartype'];
        delete this.params['bodytype'];
        delete this.params['search'];
        delete this.params['fueltype'];
        delete this.params['pricemin'];
        delete this.params['pricemax'];
      }
      if (this.params['type'] == 'new') {
        delete this.params['yearmin'];
        delete this.params['yearmax'];
        delete this.params['kilomin'];
        delete this.params['kilomax'];
      }
      this.searchForm.controls['yearmin'].setValue(this.params['yearmin'] == '' || this.params['yearmin'] == '-1' || this.params['yearmin'] == undefined ? -1 : this.params['yearmin']);
      this.searchForm.controls['yearmax'].setValue(this.params['yearmax'] == '' || this.params['yearmax'] == '-1' || this.params['yearmax'] == undefined ? -1 : this.params['yearmax']);
      this.searchForm.controls['kilomin'].setValue(this.params['kilomin']);
      this.searchForm.controls['kilomax'].setValue(this.params['kilomax']);
      this.searchForm.controls['geartype'].setValue(this.params['geartype'] == '' || this.params['geartype'] == '-1' || this.params['geartype'] == undefined ? -1 : this.params['geartype']);
      this.searchForm.controls['bodytype'].setValue(this.params['bodytype'] == '' || this.params['bodytype'] == '-1' || this.params['bodytype'] == undefined ? -1 : this.params['bodytype']);
      this.searchForm.controls['search'].setValue(this.params['search']);
      this.searchForm.controls['fueltype'].setValue(this.params['fueltype'] == '' || this.params['fueltype'] == '-1' || this.params['fueltype'] == undefined ? -1 : this.params['fueltype']);
      this.searchForm.controls['pricemin'].setValue(this.params['pricemin']);
      this.searchForm.controls['pricemax'].setValue(this.params['pricemax']);
      this.searchForm.controls['sizes'].setValue(this.params['sizes']);
      this.searchForm.controls['range'].setValue(this.params['range']);
      this.updateUrl();
    },
      10
    );
    this.params['page'] = '1';
    this.params[param] = line;
    this.getMakes();
    this.getModelYears();
    this.getseries(this.params['make']);
    this.params['page'] = '1';

    this.locationgo();
    var pagemodule = document.location.pathname.split('/').join('');

    pagemodule = pagemodule == '' ? 'home' : pagemodule;
    pagemodule = pagemodule == 'service' ? 'servicebookings' : pagemodule;
    pagemodule = pagemodule == 'parts' ? 'serviceandparts' : pagemodule;

    pagemodule = pagemodule.includes('buystock')
      ? 'preownedvehicles'
      : pagemodule;
    pagemodule = pagemodule.includes('buynew') ? 'newvehicles' : pagemodule;

    pagemodule =
      pagemodule == 'buy' &&
        (document.location.search.includes('used') ||
          document.location.search.includes('demo'))
        ? 'preownedvehicles'
        : pagemodule;
    pagemodule =
      pagemodule == 'buy' && (document.location.search.includes('new') || document.location.search.includes('newstock') || document.location.search.includes('commercials'))
        ? 'newvehicles'
        : pagemodule;

    this.chatService.loadChat(pagemodule);

  }
  select(param: string, e: any) {
    this.params['page'] = '1';
    this.singleChecked = true;
    e?.target
      ? (this.params[param] =
        e.target.value == -1 || e.target.value == undefined
          ? ''
          : e.target.value)
      : (this.params[param] = e == -1 || e == undefined ? '' : e);

    switch (param) {
      case 'yearmin':
      case 'yearmax':
        if (Number(this.params['yearmin']) > Number(this.params['yearmax'])) {
          var v = this.params['yearmin'];
          this.params['yearmin'] = this.params['yearmax'];
          this.params['yearmax'] = v;
          this.searchForm.controls['yearmin'].value;
          this.searchForm.controls['yearmin'].setValue(this.params['yearmin']);
          this.searchForm.controls['yearmax'].value;
          this.searchForm.controls['yearmax'].setValue(this.params['yearmax']);
        }
        break;

      case 'pricemin':
      case 'pricemax':
        if (Number(this.params['pricemin']) && Number(this.params['pricemax'])) {
          if (Number(this.params['pricemin']) > Number(this.params['pricemax'])) {
            var v = this.params['pricemin'];
            this.params['pricemin'] = this.params['pricemax'];
            this.params['pricemax'] = v;
            this.searchForm.controls['pricemin'].value;
            this.searchForm.controls['pricemin'].setValue(
              this.params['pricemin']
            );
            this.searchForm.controls['pricemax'].value;
            this.searchForm.controls['pricemax'].setValue(
              this.params['pricemax']
            );
          }
        }
        break;

      case 'kilomin':
      case 'kilomax':
        if (Number(this.params['kilomin']) && Number(this.params['kilomax'])) {
          if (Number(this.params['kilomin']) > Number(this.params['kilomax'])) {
            var v = this.params['kilomin'];
            this.params['kilomin'] = this.params['kilomax'];
            this.params['kilomax'] = v;
            this.searchForm.controls['kilomin'].value;
            this.searchForm.controls['kilomin'].setValue(this.params['kilomin']);
            this.searchForm.controls['kilomax'].value;
            this.searchForm.controls['kilomax'].setValue(this.params['kilomax']);
          }
        }
        break;
    }

    this.locationgo();
    this.updateUrl();
  }

  makeselect(e: any) {
    delete this.params['series'];
    this.singleChecked = true;
    this.searchForm.controls['series'].setValue(-1);
    this.select('make', e);
    this.getseries(e.target.value);
  }

  getModelYears() {
    var StockTypeID = this.params['type'] == 'used' ? 2 :
      this.params['type'] == 'demo' ? 3 : this.params['type'] == '' || this.params['type'] == undefined ? 0 : null
    if (StockTypeID != null) {
      this.apiservice
        .get('VehicleModelYears', {
          Active: true,
          Deleted: false,
          SiteID_FK: this.Site.SiteID_PK,
          VehicleStockTypeID: StockTypeID == 0 ? undefined : StockTypeID
        })
        .then((x: any) => {
          this.ModelYears = x.body;
        })
    }
  }

  getseries(e: any) {
    this.Series = [];
    if (this.params['type'] && this.params['type'] !== '') {
      if (this.params['type'] == 'new' || this.params['type'] == 'commercials') {
        this.apiservice
          .get('VehicleSeries', {
            Active: true,
            Deleted: false,
            OrderBy: 'Name.ASC',
            PageNumber: 1,
            PageSize: 9999,
            SiteID_FK: this.Site.SiteID_PK,
            loadListType: 'Dropdown_New',
            VehicleMakeID_FK: e == -1 ? undefined : e,
            VehicleTypeID_FK: this.params['type'] == 'commercials' ? 2 : undefined,
            IsCommercialSite: this.DealerCategories.Commercials
          })
          .then((x: any) => {
            x.body.forEach((ser: any) => {
              if (ser.VehicleModelsCount > 0) this.Series.push(ser);
            });
            this.updateUrl();
          });
      }
      if (this.params['type'].includes('specials')) {
        this.apiservice
          .get('VehicleSeries', {
            Active: true,
            Deleted: false,
            OrderBy: 'Name.ASC',
            PageNumber: 1,
            PageSize: 9999,
            SiteID_FK: this.Site.SiteID_PK,
            loadListType: 'Dropdown_Special',
            VehicleMakeID_FK: e == -1 ? undefined : e,
          })
          .then((x: any) => {
            x.body.forEach((ser: any) => {
              if (ser.VehicleModelsCount > 0) this.Series.push(ser);
            });
            this.updateUrl();
          });

      }
      if (this.params['type'] == 'used') {
        this.apiservice
          .get('VehicleSeries', {
            Active: true,
            Deleted: false,
            OrderBy: 'Name.ASC',
            PageNumber: 1,
            PageSize: 9999,
            SiteID_FK: this.Site.SiteID_PK,
            loadListType: 'Dropdown_Used',
            VehicleStockTypeID_FK: '2',
            VehicleMakeID_FK: e == -1 ? undefined : e,
          })
          .then((x: any) => {
            x.body.forEach((ser: any) => {
              if (ser.VehicleModelsCount > 0) this.Series.push(ser);
            });
            this.updateUrl();
          });
      }
      if (this.params['type'] == 'newstock') {
        this.apiservice
          .get('VehicleSeries', {
            Active: true,
            Deleted: false,
            OrderBy: 'Name.ASC',
            PageNumber: 1,
            PageSize: 9999,
            SiteID_FK: this.Site.SiteID_PK,
            loadListType: 'Dropdown_Used',
            VehicleStockTypeID_FK: '1',
            VehicleMakeID_FK: e == -1 ? undefined : e,
          })
          .then((x: any) => {
            x.body.forEach((ser: any) => {
              if (ser.VehicleModelsCount > 0) this.Series.push(ser);
            });
            this.updateUrl();
          });
      }
      if (this.params['type'] == 'demo') {
        this.apiservice
          .get('VehicleSeries', {
            Active: true,
            Deleted: false,
            OrderBy: 'Name.ASC',
            PageNumber: 1,
            PageSize: 9999,
            SiteID_FK: this.Site.SiteID_PK,
            loadListType: 'Dropdown_Used',
            VehicleStockTypeID_FK: '3',
            VehicleMakeID_FK: e == -1 ? undefined : e,
          })
          .then((x: any) => {
            x.body.forEach((ser: any) => {
              if (ser.VehicleModelsCount > 0) this.Series.push(ser);
            });
            this.updateUrl();
          });
      }
    } else {
      this.apiservice
        .get('VehicleSeries', {
          Active: true,
          Deleted: false,
          OrderBy: 'Name.ASC',
          PageNumber: 1,
          PageSize: 9999,
          SiteID_FK: this.Site.SiteID_PK,
          loadListType: 'Dropdown_New',
          VehicleMakeID_FK: e == -1 ? undefined : e,

        })
        .then((series: any) => {
          series.body.forEach((ser: any) => {
            if (ser.VehicleModelsCount > 0) this.Series.push(ser);
          });
          this.apiservice
            .get('VehicleSeries', {
              Active: true,
              Deleted: false,
              OrderBy: 'Name.ASC',
              PageNumber: 1,
              PageSize: 9999,
              SiteID_FK: this.Site.SiteID_PK,
              loadListType: 'Dropdown_Used',
              VehicleStockTypeID_FK: '2',
              VehicleMakeID_FK: e == -1 ? undefined : e,
            })
            .then((series: any) => {
              series.body.forEach((ser: any) => {
                if (
                  ser.VehicleModelsCount > 0 &&
                  this.Series.findIndex(
                    (x: any) => x.VehicleSeriesID_PK == ser.VehicleSeriesID_PK
                  ) == -1
                )
                  this.Series.push(ser);
              });
              this.apiservice
                .get('VehicleSeries', {
                  Active: true,
                  Deleted: false,
                  OrderBy: 'Name.ASC',
                  PageNumber: 1,
                  PageSize: 9999,
                  SiteID_FK: this.Site.SiteID_PK,
                  loadListType: 'Dropdown_Used',
                  VehicleStockTypeID_FK: '3',
                  VehicleMakeID_FK: e == -1 ? undefined : e,
                })
                .then((series: any) => {
                  series.body.forEach((ser: any) => {
                    if (
                      ser.VehicleModelsCount > 0 &&
                      this.Series.findIndex(
                        (x: any) =>
                          x.VehicleSeriesID_PK == ser.VehicleSeriesID_PK
                      ) == -1
                    )
                      this.Series.push(ser);
                    this.updateUrl();
                  });

                  this.Series = this.Series.sort((x: any, y: any) => {
                    if (x.Name > y.Name) {
                      return 1;
                    }

                    if (x.Name < y.Name) {
                      return -1;
                    }

                    return 0;
                  });

                });
            });
        });

    }
  }
  alert() {
    var data = this.params;
    this.modalService.open('alerts', data);
  }

  finance(price: number, currency: any) {
    this.modalService.open('finance', price, currency);
  }

  specialTypeExists(name: string) {
    return (
      this.SpecialsCategories.find((s: any) => s.Code == name) !== undefined
    );
  }

  selectSpecialType(name: string) {
    this.params['page'] = '1';
    this.params['type'] = name + ' specials';
    this.updateUrl();
    if (name == '') {
      this.params['specialType'] = '';
    } else {
      this.params['specialType'] = this.SpecialsCategories.find(
        (s: any) => s.Code == name
      ).SpecialCategoryID_PK;
    }
    this.locationgo();
  }

  selectedSpecialType(name: string) {
    if (
      !this.params['specialType'] ||
      this.params['specialType'] == '' ||
      this.params['specialType'] == null
    ) {
      return name == '';
    } else {
      if (this.SpecialsCategories && this.SpecialsCategories.length > 0) {
        var ffs = String(this.SpecialsCategories[0].SpecialCategoryID_PK);
        return (
          this.SpecialsCategories.find(
            (s: any) => s.SpecialCategoryID_PK == this.params['specialType']
          ).Code == name
        );
      } else {
        return false;
      }
    }
  }

  monthlyPayment(price: any) {
    var vp = parseInt(price), //vehicle price incl vat
      // deposit as percentage. ie 10% will be passed through as 0.1
      dpamt = (vp * environment.FinanceDeposit) / 100, //deposit amount
      tm = environment.FinanceMonths, //terms month
      i = environment.FinanceInterest / 100, //interest rate
      loan = 0,
      MonPmt = 0,
      balloonAmount = (environment.FinanceBalloon / 100) * vp;
    loan = vp + environment.initfee - dpamt; //additional amounts are normally what mccarthy add on (once off fee R1140 and R57 per month)
    i /= 12;

    MonPmt = Math.ceil(
      (loan * Math.pow(1 + i, tm)) / ((Math.pow(1 + i, tm) - 1) / i) -
      balloonAmount / ((Math.pow(1 + i, tm) - 1) / i)
    );

    return MonPmt + environment.adminfee;
  }

  getMakes() {
    this.Makes = [];
    if (this.params['type'] && this.params['type'] !== '') {
      if (this.params['type'] == 'new' || this.params['type'] == 'commercials') {
        this.makesservice.getSiteMakes().then((x: any) => {
          this.Makes = x;
          this.getVATStatus();
          if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
            this.searchForm.controls['make'].setValue(-1);
            this.updateUrl();
          }
        });
      }
      if (this.params['type'] == 'used') {
        this.makesservice.getStock(2).then((x: any) => {
          this.Makes = x;
          if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
            this.params['make'] = '';
            this.searchForm.controls['make'].setValue(-1);
            this.getvehicles();
            this.getseries(-1);
          }
          this.updateUrl();
        });
      }
      if (this.params['type'] == 'newstock') {
        this.makesservice.getStock(1).then((x: any) => {
          this.Makes = x;
          if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
            this.params['make'] = '';
            this.searchForm.controls['make'].setValue(-1);
            this.getvehicles();
            this.getseries(-1);
          }
          this.updateUrl();
        });
      }
      if (this.params['type'] == 'demo') {
        this.makesservice.getStock(3).then((x: any) => {
          this.Makes = x;
          if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
            this.params['make'] = '';
            this.searchForm.controls['make'].setValue(-1);
            this.getvehicles();
            this.getseries(-1);
          }
          this.updateUrl();
        });
      }
      if (this.params['type'].includes('specials')) {
        this.makesservice.getSpecials().then((x: any) => {
          this.Makes = x;
          if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
            this.params['make'] = '';
            this.searchForm.controls['make'].setValue(-1);
            this.getvehicles();
            this.getseries(-1);
          }
          this.updateUrl();
        });
      }
    } else {
      this.makesservice.getStock().then((x: any) => {
        this.Makes = x;
        this.getVATStatus();
        if (this.Makes.findIndex((x: any) => x.VehicleMakeID_PK == this.params['make']) == -1) {
          this.params['make'] = '';
          this.searchForm.controls['make'].setValue(-1);
          this.getvehicles();
          this.getseries(-1);
        }
        this.updateUrl();
      });
    }
  }

  VatExclusive(vehicleType: any, vehicleMake: any) {
    return this.VehicleMakeTypeExcludeVAT.some((x: any) => x.VehicleTypeName == vehicleType && x.VehicleMake == vehicleMake);
  }

  getVATStatus() {
    // if (this.Site.layoutFeatures.includes('vatexclusivelabel')){
    this.apiservice.get('SiteBrandVehicleTypes', {
      OrderBy: 'Name.ASC',
      PageNumber: 1,
      PageSize: 9999,
      SiteID_FK: this.Site.SiteID_PK,
      Active: true,
      Deleted: false
    }).then((x: any) => {
      let SBVT = x.body;
      SBVT = SBVT.filter((obj: any) => obj.VatInclusive == false);
      let VehicleMakeType: any = [];
      const arrPost = []
      for (let i = 0; i < SBVT.length; i++) {
        VehicleMakeType.push(SBVT[i]);
        arrPost.push(this.apiservice.get('BrandVehicleMakes',
          {
            BrandID_FK: SBVT[i].BrandID_FK,
            Active: true,
            Deleted: false,
            PageNumber: 1,
            PageSize: 9999,
            OrderBy: ''
          }
        ));
      }
      Promise.all(arrPost).then((vals: any) => {
        for (let i = 0; i < vals.length; i++) {
          const _make = this.Makes.find((m: any) => m.VehicleMakeID_PK = vals[i].body[0].VehicleMakeID_FK)
          VehicleMakeType[i].VehicleMake = _make.Name;
        }
        this.VehicleMakeTypeExcludeVAT = VehicleMakeType;
      })
    });
    // }
  }
  prefetchPages(type: string | null = null) {
    if (!environment.dissableCache) {
      let prevPageNum = (parseInt(this.params['page']) - 1);
      let nextPageNum = (parseInt(this.params['page']) + 1);

      if (type && type == 'NewModel') {
        if (prevPageNum > 0) {
          this.apiservice
            .get('VehicleModels', {
              VehicleMakeID_FK: this.params['make']
                ? this.params['make']
                : undefined,
              PageSize: 8,
              PageNumber: prevPageNum.toString(),
              OrderBy: this.customOrder ? this.customOrder : this.params['sort'],
              MaxPrice: this.params['pricemax'],
              MinPrice: this.params['pricemin'],
              VehicleTransmissionId_FK: this.params['geartype'],
              VehicleTypeID_FK: this.params['type'] == 'commercials' ? 2 : this.params['bodytype'],
              VehicleFuelTypeID_FK: this.params['fueltype'],
              DealershipID_FK: this.params['dealership'],
              RegionID_FK: this.params['region'],
              Search: this.params['search'],
              VehicleSeriesID_FK: this.params['series']
                ? this.params['series']
                : undefined,
              SiteID_FK: this.Site.SiteID_PK,
              IsCommercialSite: this.DealerCategories.Commercials ? 1 : 0,
              MaxVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.max,
              MinVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.min,
              VehicleTypeBodyType: this.Range?.find((data: any) => data.name == this.params['range'])?.name
            });
        }
        this.apiservice
          .get('VehicleModels', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            PageSize: 8,
            PageNumber: nextPageNum.toString(),
            OrderBy: this.customOrder ? this.customOrder : this.params['sort'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            VehicleTransmissionId_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['type'] == 'commercials' ? 2 : this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            SiteID_FK: this.Site.SiteID_PK,
            IsCommercialSite: this.DealerCategories.Commercials ? 1 : 0,
            MaxVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.max,
            MinVehicleWeight: this.Sizes?.find((data: any) => data.name == this.params['sizes'])?.min,
            VehicleTypeBodyType: this.Range?.find((data: any) => data.name == this.params['range'])?.name
          });
      }
      else if (type) {
        if (prevPageNum > 0) {
          this.apiservice
            .get('VehicleStock', {
              VehicleMakeID_FK: this.params['make']
                ? this.params['make']
                : undefined,
              VehicleStockType: type.toUpperCase(),
              PageSize: 8,
              PageNumber: prevPageNum.toString(),
              OrderBy: this.params['sort'],
              VehicleSeriesID_FK: this.params['series']
                ? this.params['series']
                : undefined,
              VehicleModelID_FK: this.params['model']
                ? this.params['model']
                : undefined,
              MaxYear: this.params['yearmax'],
              MinYear: this.params['yearmin'],
              MaxPrice: this.params['pricemax'],
              MinPrice: this.params['pricemin'],
              MaxMileage: this.params['kilomax'],
              MinMileage: this.params['kilomin'],
              VehicleTransmissionID_FK: this.params['geartype'],
              VehicleTypeID_FK: this.params['bodytype'],
              VehicleFuelTypeID_FK: this.params['fueltype'],
              DealershipID_FK: this.params['dealership'],
              RegionID_FK: this.params['region'],
              Search: this.params['search'],
              SiteID_FK: this.Site.SiteID_PK,
            })
        };
        this.apiservice
          .get('VehicleStock', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            VehicleStockType: type.toUpperCase(),
            PageSize: 8,
            PageNumber: nextPageNum.toString(),
            OrderBy: this.params['sort'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            VehicleModelID_FK: this.params['model']
              ? this.params['model']
              : undefined,
            MaxYear: this.params['yearmax'],
            MinYear: this.params['yearmin'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            MaxMileage: this.params['kilomax'],
            MinMileage: this.params['kilomin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            SiteID_FK: this.Site.SiteID_PK,
          });
      }
      else {
        if (prevPageNum > 0) {
          this.apiservice
            .get('AllVehicles', {
              VehicleMakeID_FK: this.params['make']
                ? this.params['make']
                : undefined,
              PageSize: 8,
              PageNumber: prevPageNum.toString(),
              OrderBy: this.params['sort'],
              MaxYear: this.params['yearmax'],
              MinYear: this.params['yearmin'],
              MaxPrice: this.params['pricemax'],
              MinPrice: this.params['pricemin'],
              MaxMileage: this.params['kilomax'],
              MinMileage: this.params['kilomin'],
              VehicleTransmissionID_FK: this.params['geartype'],
              VehicleTransmissionId_FK: this.params['geartype'],
              VehicleTypeID_FK: this.params['bodytype'],
              VehicleFuelTypeID_FK: this.params['fueltype'],
              DealershipID_FK: this.params['dealership'],
              RegionID_FK: this.params['region'],
              Search: this.params['search'],
              VehicleSeriesID_FK: this.params['series']
                ? this.params['series']
                : undefined,
              SiteID_FK: this.Site.SiteID_PK,
              PreownedLast: this.IsAlternativeDetails ? true : false
            })
        }
        this.apiservice
          .get('AllVehicles', {
            VehicleMakeID_FK: this.params['make']
              ? this.params['make']
              : undefined,
            PageSize: 8,
            PageNumber: nextPageNum.toString(),
            OrderBy: this.params['sort'],
            MaxYear: this.params['yearmax'],
            MinYear: this.params['yearmin'],
            MaxPrice: this.params['pricemax'],
            MinPrice: this.params['pricemin'],
            MaxMileage: this.params['kilomax'],
            MinMileage: this.params['kilomin'],
            VehicleTransmissionID_FK: this.params['geartype'],
            VehicleTransmissionId_FK: this.params['geartype'],
            VehicleTypeID_FK: this.params['bodytype'],
            VehicleFuelTypeID_FK: this.params['fueltype'],
            DealershipID_FK: this.params['dealership'],
            RegionID_FK: this.params['region'],
            Search: this.params['search'],
            VehicleSeriesID_FK: this.params['series']
              ? this.params['series']
              : undefined,
            SiteID_FK: this.Site.SiteID_PK,
            PreownedLast: this.IsAlternativeDetails ? true : false
          })
      }
    }
  }

  titleCase(str: string = '') {
    if (str != undefined && str != null && str != '') {
      return str.toLowerCase().replace(/(?:^|\s)\w/g, function(match: any) {
        return match.toUpperCase();
    });
    } else {
      return '';
    }
  }
}

const routes: Routes = [
  {
    path: '',
    component: BuyComponent,
    data: { Module: 'Buy', Title: 'Buy' },
  },
];

@NgModule({
  declarations: [BuyComponent, SortComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SliderModule,
    RouterModule.forChild(routes),
  ],
})
export class BuyModule { }
